import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import CDesign from '../../assets/logo.svg'; // Large screenlogo file
import CDesignSmall from '../../assets/logo.png';  // Small screenlogo file
import { AiOutlineClose } from "react-icons/ai";
import { FaBars } from "react-icons/fa";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav>
      {/* Brand Identity */}
      <div className="brand">
        <Link to="/">
            <img src={CDesign} width={200} alt="Congolese Design Logo" className="logo-lg" />
        </Link>
            <img src={CDesignSmall} width={40} alt="Congolese Design Logo" className="logo-sm" />
      </div>

      {/* Desktop Navigation Wrapper */}
      <div className="desktop-menu">
        <NavLink 
          to="/" 
          className={({ isActive }) => (isActive ? "active" : "navl-link")}
        >
          Home
        </NavLink>
        <NavLink 
          to="/about" 
          className={({ isActive }) => (isActive ? "active" : "navl-link")}
        >
          About
        </NavLink>
        <NavLink 
          to="/expertise" 
          className={({ isActive }) => (isActive ? "active" : "navl-link")}
        >
          Expertise
        </NavLink>
        <NavLink 
          to="/portfolio" 
          className={({ isActive }) => (isActive ? "active" : "navl-link")}
        >
          Portfolio
        </NavLink>
        <NavLink 
          to="/contact" 
          className={({ isActive }) => (isActive ? "active" : "navl-link")}
        >
          Connect
        </NavLink>
      </div>

      {/* Mobile Toggle Button */}
      <button onClick={toggleMenu} className='toggle-btn'>
        {isOpen ? <AiOutlineClose className='close' /> : <FaBars className='open' />}
      </button>

      {/* Mobile Navigation Wrapper */}
      {isOpen && (
        <div className="mobile-menu">
          <NavLink 
            to="/" 
            className={({ isActive }) => (isActive ? "active" : "navl-link")} 
            onClick={toggleMenu}
          >
            Home
          </NavLink>
          <NavLink 
            to="/about" 
            className={({ isActive }) => (isActive ? "active" : "navl-link")} 
            onClick={toggleMenu}
          >
            About
          </NavLink>
          <NavLink 
            to="/expertise" 
            className={({ isActive }) => (isActive ? "active" : "navl-link")} 
            onClick={toggleMenu}
          >
            Expertise
          </NavLink>
          <NavLink 
            to="/portfolio" 
            className={({ isActive }) => (isActive ? "active" : "navl-link")} 
            onClick={toggleMenu}
          >
            Portfolio
          </NavLink>
          <NavLink 
            to="/contact" 
            className={({ isActive }) => (isActive ? "active" : "navl-link")} 
            onClick={toggleMenu}
          >
            Contact
          </NavLink>
        </div>
      )}
    </nav>
  );
};

export default Navbar;